const messages = {
  name: 'Usuarios de administracion |||| Usuarios de administracion',
  fields: {
    name: 'Nombre',
    surname: 'Apellido',
    email: 'Email',
    role: 'Rol',
    status: 'Estado',
    origin: 'Origen',
    password: 'Contrasena temporal',
    newPassword: 'Nueva contrasena',
    confirmPassword: 'Confirmar contrasena',
  },
  columns: {
    actions: 'Acciones',
  },
  filters: {
    name: 'Nombre',
    surname: 'Apellido',
    email: 'Email',
  },
  roles: {
    SuperUser: 'SuperUser',
    Maintenance: 'Maintenance',
  },
  status: {
    active: 'Activo',
    blocked: 'Bloqueado',
  },
  badges: {
    realm: 'Rol de realm',
    realmHelp:
      'Su acceso viene de un rol del realm, compartido con el resto de productos Roommatik. El rol se cambia en Keycloak, no aqui.',
    service: 'Servicio',
    serviceHelp: 'Cuenta de servicio de Keycloak (integracion), no una persona.',
    noProfile: 'Sin ficha',
    noProfileHelp:
      'No tiene fila en la tabla de usuarios: entra al admin, pero "Mi perfil" no carga. Se arregla sola al editarlo aqui.',
  },
  actions: {
    addUser: 'Anadir administrador',
    changePassword: 'Cambiar contrasena',
    block: 'Bloquear (conserva el rol, no podra entrar)',
    unblock: 'Desbloquear',
    revoke: 'Retirar acceso al admin',
    revokeConfirm: 'Retirar acceso',
  },
  dialog: {
    create: 'Nuevo administrador',
    edit: 'Editar administrador',
    changePassword: 'Cambiar contrasena de %{email}',
  },
  help: {
    superUserOnly:
      'Solo un SuperUser puede ver y gestionar los usuarios de administracion.',
    intro:
      'Quien puede entrar a ESTE backoffice. El acceso lo concede un rol de Keycloak, por eso aqui aparecen tambien los administradores creados a mano en su consola. Los usuarios del portal y del contact center de un cliente estan en Gestion de usuarios.',
    roleSuperUser: 'Acceso completo, incluidos estos mismos usuarios de administracion.',
    roleMaintenance:
      'Soporte: gestiona cuentas de punta a punta, pero no proveedores, licencias, tarifas ni administradores.',
    passwordOptional:
      'Opcional. Si lo dejas vacio, Keycloak le envia un correo para que la establezca el mismo.',
    temporaryPassword:
      'Contrasena temporal: Keycloak le pedira cambiarla al entrar. Minimo 12 caracteres con mayuscula, minuscula, numero y simbolo.',
    realmRoleLocked:
      'Su acceso viene de un rol del realm, que comparten los demas productos Roommatik. Se pueden cambiar sus datos, pero el rol hay que cambiarlo en Keycloak: quitarselo desde aqui podria dejarle sin acceso a otras aplicaciones.',
  },
  revoke: {
    title: 'Retirar el acceso al admin a %{email}?',
    content:
      'Se le quitan los roles de backoffice del cliente de notify. NO se borra su usuario de Keycloak: el realm es compartido con el resto de productos Roommatik y borrarlo le dejaria fuera de todos. Podras volver a darle acceso cuando quieras.',
  },
  validation: {
    emailRequired: 'El email es obligatorio',
    emailInvalid: 'Email no valido',
    passwordRequired: 'La contrasena es obligatoria',
    passwordPattern:
      'Minimo 12 caracteres, con mayuscula, minuscula, numero y simbolo',
    confirmPasswordRequired: 'Confirma la contrasena',
    confirmPasswordMismatch: 'Las contrasenas no coinciden',
  },
  notifications: {
    created: 'Administrador creado',
    updated: 'Administrador actualizado',
    blocked: 'Usuario bloqueado',
    unblocked: 'Usuario desbloqueado',
    revoked: 'Acceso retirado',
    passwordSet: 'Contrasena actualizada',
  },
};

export default messages;
